import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'
import * as common from '../common'

@ngCore.Component({
  imports: [
    ds.layout.page.Component,
    ds.overlay.confirmation.Component,
    ds.table.Component,
    common.dialogs.widget.Component,
  ],
  selector: 'atn-mosaic-dev-widgets-page',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.mosaic.dev.widgets.Collection} */
  public readonly widgetsEc = ngCore.inject(state.mosaic.dev.widgets.Collection)

  /** Canonical table input for Mosaic widget definitions. */
  public readonly widgetsTableConfig = {
    collection: this.widgetsEc,
    view: {
      creation: () => this.addClickHandlerCallback(),
      search: true,
      title: 'Widgets',
    },
  } satisfies ds.table.ec.Config.Input<state.mosaic.dev.widgets.TypeParams>

  public addClickHandlerCallback = () => {
    if (
      this.widgetsEc.plugins.currentEntityPlugin.feature.selectors
        .getEditedEntity()
        .asSignal()
    ) {
      this.widgetsEc.plugins.editingPlugin.feature.actions.discard
        .from('Table.AddButton.Clicked')
        .dispatch({
          current: true,
        })
    }

    // add new widget
    this.widgetsEc.plugins.editingPlugin.feature.actions.edit
      .from('Table.AddButton.Clicked')
      .dispatch({
        edit: {
          input: {
            name: 'New widget',
          },
        },
      })
  }

  public confirmDeletionClickHandler(): void {
    this.widgetsEc.plugins.editingPlugin.feature.actions.submit
      .from('Confirmation.Footer.Buttons.Confirm.Clicked')
      .dispatch({ delete: true })
  }

  public cancelDeletionClickHandler(): void {
    this.widgetsEc.plugins.editingPlugin.feature.actions.discard
      .from('Confirmation.Footer.Buttons.Cancel.Clicked')
      .dispatch({ delete: true })
  }
}
